import { surgery } from '../../api'

const state = {
  surgery: {
    contentList: [],
    surgeryReview: {
      title: '',
      content: '',
      image: '',
      date: ''
    }
  }
}

const getters = {
  getSurgeryReviewList: state => state.surgery.contentList,
  getSurgeryReview: state => state.surgery.surgeryReview
}

const mutations = {
  SET_SURGERY_REVIEW_LIST (state, payload) {
    state.surgery.contentList = payload
  },
  SET_SURGERY_REVIEW (state, payload) {
    state.surgery.surgeryReview = payload
  }
}

const actions = {
  SURGERY_REVIEW_LIST ({ commit }) {
    return surgery.surgeryReviewList()
      .then((data) => commit('SET_SURGERY_REVIEW_LIST', data.response.contentList))
  },
  SURGERY_REVIEW ({ commit }, payload) {
    return surgery.surgeryReview(payload)
      .then((data) => commit('SET_SURGERY_REVIEW', data.response.surgeryReview))
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
